<template>
  <div class="preferential" ref="preferential">
    <!-- 优惠政策 -->
    <div class="nav_box">
      <Nav :isClass="isClass" :active="4"></Nav>
    </div>
    <div class="banner">
      <img class="banner_img" @click="goUrl" src="../assets/img/位图@2x(1)(2).png">
      <!-- <div class="banner_title" @click="goUrl">金华市算力补贴申领入口</div> -->
      <!-- <div class="banner_new">算力资源运营系统面向SaaS应用平台和第三方资源互联互通的开放API接口</div> -->
    </div>
    <div class="content_box">
      <div class="bg">
        <div class="list_box">
          <div class="list_item" v-for="(item, index) in listData" :key="index">
            <img src="../assets/img/位图@2x (20).png">
            <div class="inner_box">
              <div class="inner_title">
                <div class="title_top">{{ item.title }}</div>
                <div class="title_bot">{{ item.inner }}</div>
              </div>
              <div class="submit_btn" @click="toLink(item)">
                详情
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
    <!-- <div class="footer">
      <div class="cente">
        <img class="footer_img" src="../assets/img/位图@2x(1)(2).png">
        <img @click="goUrl" class="footer_btn" src="../assets/img/位图@2x(16).png">
      </div>
    </div> -->
    <!-- <div class="footer_fout"><Clas></Clas></div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClass: false,
      listData: [{
        // url: require('../assets/img/act-2.png'),
        title: '金华市人工智能算力补贴政策',
        inner: '关于组织2024年金华市人工智能算力补贴的通知',
        link: 'http://www.jinhua.gov.cn/art/2024/7/26/art_1229160385_1806792.html'
      }
        // , {
        //   title: '金华市算力优惠券',
        //   inner: '优惠券发放'
        // }
      ]
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    let minWidth = window.screen.width;
    this.$refs["preferential"].style.minWidth = minWidth + "px";
    window.addEventListener('scroll', this.mouseWheelHandle, true);
  },
  methods: {
    mouseWheelHandle() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        this.isClass = true
      } else {
        this.isClass = false
      }
    },
    goUrl() {
      window.open('https://czbz.czj.jinhua.gov.cn:9443/apply?batchid=202406251120590328841JYlh&forTest=1')
    },
    toLink(event) {
      if (event.link) {
        window.open(event.link)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.mouseWheelHandle);
  },

}
</script>

<style lang="scss" scoped>
.preferential {}

.nav_box {
  position: fixed;
  // position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
}

.banner {
  width: 100%;
  height: 700px;
  background-image: url("../assets/img/位图@2x (17).png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .banner_img {
    width: 597px;
    height: 94px;
    cursor: pointer;
  }

  .banner_title {
    text-align: center;
    font-weight: 500;
    font-size: 50px;
    color: #FFFFFF;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .banner_new {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
  }
}

.content_box {
  background-color: #EAEEF0;

  .bg {
    padding: 50px 0;
    background-image: url("../assets/img/bg2_left.png"), url("../assets/img/bg2_right.png");
    background-repeat: no-repeat;
    background-size: 576px 458px;
    background-position: left top, right bottom;

    .list_box {
      .list_item {
        width: 1200px;
        display: flex;
        background-color: #FFFFFF;
        margin: 20px auto;
        padding: 20px;

        img {
          width: 240px;
          height: 135px;
        }

        .inner_box {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .inner_title {
            .title_top {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #333333;
            }

            .title_bot {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #6C6C6C;
              margin-top: 10px;
            }
          }

          .submit_btn {
            width: 55px;
            height: 31px;
            background: #094990;
            border-radius: 3px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
            cursor: pointer;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }


    }
  }


}

.footer {
  height: 174px;
  width: 100%;
  background-image: url("../assets/img/矩形@2x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .cente {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    .footer_img {
      width: 597px;
      height: 94px;
    }

    .footer_btn {
      width: 200px;
      height: 43px;
      cursor: pointer;
    }
  }
}

.footer_fout {
  position: fixed;
  bottom: 10%;
  right: 0;
}
</style>